// eslint-disable-next-line no-shadow
export var AlignmentOptions;
(function (AlignmentOptions) {
    AlignmentOptions["LEFT"] = "left";
    AlignmentOptions["RIGHT"] = "right";
    AlignmentOptions["CENTER"] = "center";
    AlignmentOptions["EMPTY"] = "";
})(AlignmentOptions || (AlignmentOptions = {}));
//# sourceMappingURL=PlatformParams.js.map